import axios from "axios";
import Cookies from "js-cookie";

const api = axios.create({
  baseURL: "https://api.365exams.com",
  headers: {
    Accept: "*/*",
    "Access-Control-Allow-Origin": "*",
  },
});

export const getAssessment = async (id) => {
  try {
    const { data } = await api.get(`/courses/Assessments/Get?id=${id}`);
    return data;
  } catch (e) {
    console.error(e);
  }
};

export const getAssessmentQuestions = async (id, page, size) => {
  try {
    const { data } = await api.get(
      `/courses/questions/list?PageNumber=${page}&PageSize=${size}&assessmentId=${id}`
    );
    return data;
  } catch (e) {
    console.error(e);
  }
};

// One page of questions is not an exam. The app used to ask for a single page of twenty,
// so anything longer started with the rest missing - and the server still marked the
// attempt out of the full count, so a sixty-question exam capped the student at a third
// of the marks. This asks for one generous page and then follows totalItemCount for any
// remainder, so no exam can be cut short whatever its length.
const QUESTION_PAGE_SIZE = 200;

export const getAllAssessmentQuestions = async (id) => {
  const first = await getAssessmentQuestions(id, 1, QUESTION_PAGE_SIZE);
  if (!first) return null;

  const questions = [...(first.result ?? [])];
  const total = first.totalItemCount ?? questions.length;

  // Only runs if an exam ever outgrows a single page.
  for (let page = 2; questions.length < total; page += 1) {
    const next = await getAssessmentQuestions(id, page, QUESTION_PAGE_SIZE);
    const rows = next?.result ?? [];
    // An empty page means there is nothing more to collect; stop rather than loop forever.
    if (!rows.length) break;
    questions.push(...rows);
  }

  return { ...first, result: questions, totalItemCount: total };
};

export const getResults = async (values) => {

  try {
    const { data } = await api.post(
      `/courses/Assessments/Complete?id=${values.id}`,
      {
        "assessmentId": values.id,
        "answers": values.answers,
        "totalTimeElapsed": values.totalTimeElapsed
      }
     
    );
    return data;
  } catch (e) {
    console.error(e);
  }
};

export const submitReview = async (params) => {
  try {
    let result = await fetch(`https://api.365exams.com/Articles/Reviews/Add`, {
      method: "PUT",
      body: JSON.stringify(params),
      headers: {
        "Content-Type": "application/json",
      },
    });
    let data = await result.json();
    return data;
  } catch (err) {
    console.log(err);
  }
};

// Header navigation. Menu 2 is "HomePageTop" - the same menu the main site renders,
// so the two navigations can no longer drift apart when someone edits it in the admin.
// The API returns a flat list carrying parentId; the header builds the tree from that.
export const getHeaderMenu = async () => {
  try {
    const { data } = await api.get(
      "/core/MenuItems/List?menuId=2&PageNumber=1&PageSize=100"
    );
    return data?.result ?? [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

// Add request and response interceptors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.request.use(
  async (config) => {
    // Do something before request is sent
    const token = Cookies.get("Token");
    // console.log(token);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);
